import { PIPELINE_STAGES } from "./config";

export function getStageFromStatus(status) {
  for (const stage of PIPELINE_STAGES) {
    const hasStatus = stage.statuses.some(
      (item) => item.value === status
    );

    if (hasStatus) {
      return stage.key;
    }
  }

  return null;
}

export function getStatusLabel(status) {
  for (const stage of PIPELINE_STAGES) {
    const match = stage.statuses.find(
      (item) => item.value === status
    );

    if (match) {
      return match.label;
    }
  }

  return status;
}

export function getStageCounts(properties) {
  const counts = {
    all: properties.length,
  };

  PIPELINE_STAGES.forEach((stage) => {
    counts[stage.key] = 0;
  });

  properties.forEach((property) => {
    const stage = getStageFromStatus(property.status);

    if (stage && counts[stage] !== undefined) {
      counts[stage] += 1;
    }
  });

  return counts;
}